module.exports = __webpack_public_path__ + "media/images/job_from_template-6c45e694c4ef511061056eb0df1ba704.svg";